import { PackageThumbnail, UserListeningPackagesResponse } from '../../common/services/package/package.model';
import GlobalSpinnerService from '../../common/services/spinner/global-spinner.service';
import UserService from '../../common/services/user/user.service';
import StorageService from '../services/storage.service';
import UserInfoService from '../services/user-info.service';
import LanguageChangeController from '../services/language-change.controller';
import ActionDispatcherService from '../../common/actions/core/action-dispatcher.service';

export default class NoAuthOffersController extends LanguageChangeController {
  private msisdn: string;
  private packages: UserListeningPackagesResponse;
  private offerablePackages: PackageThumbnail[] = [];
  private initiated = false;

  constructor(
    actionDispatcher: ActionDispatcherService,
    private $translate,
    private storageService: StorageService,
    private globalSpinner: GlobalSpinnerService,
    private userService: UserService,
    private userInfoService: UserInfoService
  ) { super(actionDispatcher); }

  public $onInit() {
    this.msisdn = this.storageService.getMsisdn();
    if (!this.msisdn) {
      this.userService.redirectToLogin();
    }
    super.$onInit();

    this.initiateUserInfo();
  }

  protected async resetPackageNames() {
    if (this.packages) {
      this.globalSpinner.startIfNotActivated();
      await this.userInfoService.updatePackagesLanguage();
      this.packages = this.userInfoService.getPackages();
      this.offerablePackages = this.userInfoService.getOfferablePackages();
      this.globalSpinner.stop();
    }
  }

  public async initiateUserInfo() {
    if (!this.initiated) {
      this.globalSpinner.startIfNotActivated();
      await this.userInfoService.initiateAllUserInfo(this.msisdn, (key) => this.redirectToLogin(key));
      this.packages = this.userInfoService.getPackages();
      this.offerablePackages = this.userInfoService.getOfferablePackages();
      this.initiated = true;
      this.globalSpinner.stop();
    }
  }

  private redirectToLogin(key) {
    this.userService.redirectToLogin();
  }
}


// WEBPACK FOOTER //
// src/app/no-auth/offers/offers.controller.ts